import {
    APIProvider,
    Map,
    MapCameraChangedEvent,
    Marker,
} from "@vis.gl/react-google-maps";
import "./map.scss";
import {
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
} from "react-router-dom";
import { Estate, latLong } from "../../types/estate";
import { useEffect, useRef, useState } from "react";
import Mapbox from "../../components/mapbox/mapbox";
import axios from "axios";

const MapPage = () => {
    const [searchParams] = useSearchParams();
    const [apiLoaded, setApiLoaded] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const state = location.state;
    const defaultLocation: latLong = { lat: 51.5074, lng: -0.1278 };
    const lat =
        parseFloat(searchParams.get("lat") || "") || defaultLocation.lat;
    const lng =
        parseFloat(searchParams.get("lng") || "") || defaultLocation.lng;
    const estateName = searchParams.get("estate") || "" || null;

    const [estate, setEstate] = useState<Estate | null>(state?.estate || null);
    const unitLocation: latLong = { lat, lng };
    const zoom = parseFloat(searchParams.get("zoom") || "") || 12;
    const handleBack = () => {
        navigate(-1);
    };
    useEffect(() => {
        console.log(location);
    }, []);

    useEffect(() => {
        const fetchArticle = async () => {
            console.log("estate", estateName);
            try {
                const response = await axios.get(
                    `https://wp.sirendigital.uk/space-industrial/wp-json/wp/v2/posts?_embed&slug=${estateName}`
                );
                if (response.data.length > 0) {
                    setEstate(response.data[0]);
                    console.log("Test", response.data[0]);
                } else {
                    setError("Article not found");
                }
            } catch (err) {
                setError("Failed to load article");
            } finally {
                setLoading(false);
            }
        };

        fetchArticle();
    }, [estateName]);

    return (
        <div className="contain-wrapper">
            <div className="map-wrapper contain relative">
                <a onClick={handleBack} className="volt-button map-back-btn">
                    <p>Back</p>
                </a>
                <Mapbox
                    accessToken={
                        "pk.eyJ1Ijoic2lyZW5kZXNpZ24iLCJhIjoiY203ZGFrdmtrMDExcTJpc2phdXJ5MHFlaSJ9.gjwmtRshqe4uN7x-vqWJ5A"
                    }
                    initialViewState={{
                        longitude: lng,
                        latitude: lat,
                        zoom: zoom,
                    }}
                    estate={estate || undefined}
                />
                <div className="absolute p-10 bg-[#0B2F36]">
                    <h3>{estate?.acf.name}</h3>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: estate?.acf.postcode || "",
                        }}
                    />
                    <p>
                        {estate?.acf.summary_points.map(
                            (point: { summary: string }, index: number) => (
                                <span key={index}>
                                    {point.summary}
                                    <br />
                                </span>
                            )
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MapPage;
